import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

export interface DocumentDetailsResponse {
  id: string;
  name: string;
  name_malay: string;
  name_mandarin: string;
  project_airport_id: any;
  published: string;
}

// edit api call
const fetchPageContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/sub_category/${id}`);

  return response?.data[0];
};

const usePageDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["pageContenDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchPageContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePageDocumentDetails };
